import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { setConfig } from 'react-hot-loader';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Normalize } from 'styled-normalize';
import { Provider as AnalyticsProvider, tracker } from '@carvana/analytics';
import { AnalyticsProvider as EventableAnalytics } from '@carvana/eventable-clickstream';
import { theme, ModalProvider } from '@carvana/purchase-styles';
import {
  ErrorBoundary,
  ExperimentProvider,
  Debugger,
  MfeDebugger,
  UIProvider
} from '@carvana/purchase-helpers';
import { history, AnalyticsConfig, store } from 'Store';
import App from 'Components/app';
import './helpers/loadRUM';
import './index.css';
import './scripts/gtm-config';
import './scripts/xhr-extensions';
import './scripts/number-extensions';
import '@carvana/showroom-css-theme/Theme.css';
import '@carvana/showroom-forms/index.css';
import '@carvana/showroom-autocomplete/index.css';

// TODO: add UserEngagementSessionTracker from @carvana/analytics
setConfig({
  logLevel: 'no-errors-please',
  showReactDomPatchNotification: false
});

// const session = new UserEngagementSessionTracker(AnalyticsConfig);
const GlobalStyle = createGlobalStyle`
:root {
    --colors-primary-blue-1: #CFEAF2;
    --colors-primary-blue-2: #00AED9;
    --colors-primary-blue-3: #018DC0;
    --colors-primary-blue-4: #00619E;
    --colors-primary-blue-5: #045489;
    --colors-primary-blue-6: #183558;
    --colors-primary-blue-7: #122946;
    --colors-primary-yellow-1: #FBF2DE;
    --colors-primary-yellow-2: #FEB948;
    --colors-primary-yellow-3: #EB9F23;
    --colors-primary-green-1: #EBFBEE;
    --colors-primary-green-2: #2F9E44;
    --colors-primary-green-3: #237032;
    --colors-primary-red-1: #FFF5F5;
    --colors-primary-red-2: #E03131;
    --colors-neutral-white: #FFF;
    --colors-neutral-gray-1: #F4F8FA;
    --colors-neutral-gray-2: #D9DDE9;
    --colors-neutral-gray-3: #AAB1C7;
    --colors-neutral-gray-5: #6D7184;
    --colors-neutral-black: #000;
}

  html {
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  body {
    margin: auto;
    height: 100%;
    font-weight: 400;
    color: #333;
    font-family: "Brandon Text", Lato, Helvetica, sans-serif;
    font-feature-settings: 'liga' off, 'cpsp' on;
    font-size: 16px;
    line-height: 1.25;
  }

  p, h1, h2, h3 {
    margin-bottom: 0;
    margin-top: 0;
  }

  ul, ol {
    margin: 0;
    padding-left: 0;
  }
`;

const debuggerContainer = {
  position: 'fixed',
  bottom: 0,
  right: 0
};

const root = document.getElementById('root');

const Providers = ({ children }) => (
  <Provider store={store}>
    <AnalyticsProvider configs={AnalyticsConfig}>
      <EventableAnalytics
        environment={process.env.NODE_ENV}
        projectName="PurchaseUI"
        teamName="TXN"
        track="TXN"
      >
        <UIProvider>
          <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
              <>
                <GlobalStyle />
                <Normalize />
                <ErrorBoundary>
                  <ModalProvider>{children}</ModalProvider>
                </ErrorBoundary>
              </>
            </ThemeProvider>
          </ConnectedRouter>
        </UIProvider>
      </EventableAnalytics>
    </AnalyticsProvider>
  </Provider>
);

Providers.propTypes = {
  children: PropTypes.node.isRequired
};

if (root !== null) {
  // session.startTracking();
  ReactDOM.render(
    <Providers>
      <ExperimentProvider
        defaults={{
          apiTimeout: 2000,
          cacheMinutes: 15,
          defaultBucket: 'control',
          environment: process.env.NODE_ENV
        }}
      >
        <App />
        <div style={debuggerContainer}>
          <Debugger />
          <MfeDebugger />
        </div>
      </ExperimentProvider>
    </Providers>,
    root
  );
}
